import { useMutation, useQueryClient } from "react-query";

import { getAppointmentsV2QueryKeyPrefix } from "api/services/appointment/hooks/useGetAppointmentsV2";
import { getAppointmentsV2PatientQueryKeyPrefix } from "api/services/appointment/hooks/useGetAppointmentsV2Patient";
import type { AppointmentV2 } from "api/services/appointment/schemas/appointment_v2";
import { useApiClient } from "api/useApiClient";

export type PostAppointmentV2NoShow = {
  appointmentID: number;
  hcProfID: number;
};

export const usePostAppointmentV2NoShow = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<AppointmentV2, Error, PostAppointmentV2NoShow>(args => client.postAppointmentV2NoShow(args), {
    onSuccess() {
      queryClient.invalidateQueries([getAppointmentsV2QueryKeyPrefix]);
      queryClient.invalidateQueries([getAppointmentsV2PatientQueryKeyPrefix]);
    },
  });
};
